import { IApplicationState } from '../../types/redux';
import { INewbuildingFromTheBuilderSchema } from '../../repositories/newbuilding-card/entities/newbuilding_from_the_builder/NewbuildingFromTheBuilderSchema';

export function getNewbuldingFromTheBuilder({ newbuilding }: IApplicationState): INewbuildingFromTheBuilderSchema[] {
  if (newbuilding && newbuilding.newbuildingsFromTheBuilder && newbuilding.newbuildingsFromTheBuilder.length) {
    return newbuilding.newbuildingsFromTheBuilder.slice(0, 4);
  }

  return [];
}
